"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisementUtils = void 0;
class AdvertisementUtils {
    static isCI() {
        if (!this.isNodeEnvironment()) {
            return false;
        }
        return this.ciEnvVars.some((envVar) => {
            const value = process.env[envVar];
            return value !== undefined && value !== '' && value !== '0' && value !== 'false';
        });
    }
    static shouldShowAdvertisement() {
        if (!this.isNodeEnvironment()) {
            return false;
        }
        if (this.isCI()) {
            return false;
        }
        if (!process.stdout.isTTY) {
            return false;
        }
        const config = this.getConfig();
        if (!config) {
            return false;
        }
        const firstDisplayTime = this.getFirstDisplayTime(config);
        const now = Date.now();
        if (firstDisplayTime && now - firstDisplayTime >= this.resetPeriodMs) {
            this.resetDisplayData(config);
        }
        const count = this.getDisplayCount(config);
        if (count >= this.maxDisplayCount) {
            return false;
        }
        if (!firstDisplayTime || now - firstDisplayTime >= this.resetPeriodMs) {
            this.setFirstDisplayTime(config, now);
        }
        this.setDisplayCount(config, count + 1);
        return true;
    }
    static isNodeEnvironment() {
        var _a;
        return typeof process !== 'undefined' && ((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node) !== undefined;
    }
    static getConfig() {
        if (this.config) {
            return this.config;
        }
        if (typeof window === 'undefined') {
            try {
                const Conf = eval('require')('conf').default;
                this.config = new Conf({
                    projectName: 'javascript-obfuscator'
                });
                return this.config;
            }
            catch (_a) {
                return null;
            }
        }
        return null;
    }
    static getDisplayCount(config) {
        try {
            const count = config.get(this.storageKey, 0);
            return typeof count === 'number' ? count : 0;
        }
        catch (_a) {
            return 0;
        }
    }
    static setDisplayCount(config, count) {
        try {
            config.set(this.storageKey, count);
        }
        catch (_a) {
        }
    }
    static getFirstDisplayTime(config) {
        try {
            const timestamp = config.get(this.timestampKey, null);
            return typeof timestamp === 'number' ? timestamp : null;
        }
        catch (_a) {
            return null;
        }
    }
    static setFirstDisplayTime(config, timestamp) {
        try {
            config.set(this.timestampKey, timestamp);
        }
        catch (_a) {
        }
    }
    static resetDisplayData(config) {
        try {
            config.delete(this.storageKey);
            config.delete(this.timestampKey);
        }
        catch (_a) {
        }
    }
}
exports.AdvertisementUtils = AdvertisementUtils;
AdvertisementUtils.maxDisplayCount = 5;
AdvertisementUtils.storageKey = 'adDisplayCount';
AdvertisementUtils.timestampKey = 'adFirstDisplayTime';
AdvertisementUtils.resetPeriodMs = 3 * 24 * 60 * 60 * 1000;
AdvertisementUtils.ciEnvVars = [
    'CI',
    'CONTINUOUS_INTEGRATION',
    'GITHUB_ACTIONS',
    'GITLAB_CI',
    'TRAVIS',
    'CIRCLECI',
    'JENKINS_URL',
    'HUDSON_URL',
    'TEAMCITY_VERSION',
    'BUILDKITE',
    'TF_BUILD',
    'BITBUCKET_BUILD_NUMBER',
    'CODEBUILD_BUILD_ID',
    'DRONE',
    'HEROKU_TEST_RUN_ID',
    'NETLIFY',
    'VERCEL',
    'NOW_BUILDER',
    'RENDER',
    'CODESANDBOX_SSE',
    'STACKBLITZ'
];
AdvertisementUtils.config = null;
